import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { FEATURED_PACKAGES } from '../data/packages';
import { useCatalog } from '../data/catalog';
import { Kicker, Reveal } from './Reveal';
import { MarketplaceCard } from './MarketplaceCard';
import { useLang } from '../i18n';

export const FeaturedPackages = () => {
  const { t } = useLang();
  const { packages } = useCatalog();

  return (
    <section data-testid="featured-packages-section" className="bg-white py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <Reveal className="flex flex-wrap items-end justify-between gap-6">
          <div>
            <Kicker>{t('tours.home.k')}</Kicker>
            <h2 className="eco-section-title mt-4 text-eco-ink">
              {t('tours.t')}
            </h2>
            <p className="mt-2 text-sm text-eco-ink/55">{t('tours.home.s')}</p>
          </div>
          <Link
            to="/journeys"
            data-testid="packages-view-all-button"
            className="eco-btn-text group"
          >
            {t('tours.home.cta')} <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </Reveal>

        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {FEATURED_PACKAGES.map((slug, i) => {
            const p = packages.find((x) => x.slug === slug);
            return (
              <Reveal key={slug} delay={i * 0.1}>
                <MarketplaceCard
                  to={`/journeys/${slug}`}
                  testid={`featured-package-${slug}`}
                  image={p.img}
                  imageBadge={p.destination}
                  eyebrow={`${p.destination} · ${p.style}`}
                  title={p.name}
                  location={p.idealFor}
                  duration={p.duration}
                  partner={t('partners.kicker')}
                  cta={t('tours.explore')}
                />
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
